import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import Fetch from './Fetch';
import { apiURL } from '../constants';

var EnumsService =
/*#__PURE__*/
function () {
  function EnumsService() {
    _classCallCheck(this, EnumsService);

    this.cachedEnums = null;
  }

  _createClass(EnumsService, [{
    key: "getEnums",
    value: function getEnums() {
      var _this = this;

      if (this.cachedEnums) {
        return new Promise(function (resolve) {
          return resolve(_this.cachedEnums);
        });
      }

      return Fetch.getJSON(apiURL.API_ENUMS).then(function (response) {
        _this.cachedEnums = {}; // sort all enums

        Object.keys(response).forEach(function (key) {
          var lowerKey = key.charAt(0).toLowerCase() + key.slice(1);

          if (Array.isArray(response[key])) {
            _this.cachedEnums[lowerKey] = response[key].sort(function (a, b) {
              var titleA = a.title.toLowerCase();
              var titleB = b.title.toLowerCase();

              if (titleA < titleB) {
                return -1;
              }

              if (titleA > titleB) {
                return 1;
              }

              return 0;
            });
          } else {
            _this.cachedEnums[lowerKey] = response[key];
          }
        });
        return _this.cachedEnums;
      });
    }
  }]);

  return EnumsService;
}();

export default new EnumsService();